function phraseSelectionAlert() {
    let alertDiv = document.getElementById('customAlert');
    if (!alertDiv) {
        alertDiv = document.createElement('div');
        alertDiv.id = 'customAlert';
        alertDiv.style.cssText = 'display: none; position: fixed; left: 0; top: 0; width: 100%; height: 100%; background-color: rgba(0,0,0,0.5); z-index: 1000; display: flex; justify-content: center; align-items: center;';
        document.body.appendChild(alertDiv);

        alertDiv.innerHTML = `
            <div style="background-color: white; padding: 20px; border-radius: 5px; width: auto; max-width: 700px; display: flex; flex-direction: column;">
                <div style="margin-bottom: 20px;">
                    <p>${I18n.t('javascript.phrase_selection.phrase_tip')}</p>
                    <p>${I18n.t('javascript.phrase_selection.word_tip')}</p>
                </div>
                <div style="text-align: right;">
                    <button id="closeAlert" style="background-color: #00448F; color: white; border: none; padding: 10px; border-radius: 5px; cursor: pointer;">${I18n.t('javascript.phrase_selection.close')}</button>
                </div>
            </div>
        `;

        document.getElementById('closeAlert').addEventListener('click', function() {
            alertDiv.style.display = 'none';
        });
    } else {
        alertDiv.style.display = 'flex';
    }
}

module.exports = phraseSelectionAlert;